<div class="mobile-menu-container">
    <div class="mobile-menu-view">
        <div class="mobile-menu-list">
            <ccdl-link linkText="Home"
                [routeLink]="'/LandingPage/Home'"
                (onClick)="closeDialogMenuClick()"></ccdl-link>
            <ccdl-link linkText="About us"
                [routeLink]="'/LandingPage/AboutUs'"
                (onClick)="closeDialogMenuClick()"></ccdl-link>
            <ccdl-divider></ccdl-divider>
            <ccdl-link linkText="Sign In"
                (onClick)="signInClick()"></ccdl-link>
            <ccdl-link linkText="Sign Up"
                (onClick)="signUpClick()"></ccdl-link>
        </div>
    </div>
</div>
